import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withJsonpSupport } from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps';
import { MapComponent } from './map.component';

@NgModule({
    declarations: [MapComponent],
    exports: [MapComponent],
    imports: [CommonModule, GoogleMapsModule],
    providers: [provideHttpClient(withJsonpSupport())],
})
export class MapModule {}
